import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import theme from '@fortress-technology-solutions/fortress-component-library/theme';
import loadable from '@loadable/component';
import styled from 'styled-components';
import { setLocalAuth } from 'utils/auth';
import { AppContext } from 'contexts/AppContext';
import { getLocalUnitIntentData } from 'utils';
import { useFormProps } from './hooks';

const Logo = loadable(() => import('components/Atoms/Logo'));
const Link = loadable(() => import('components/Atoms/Link'));
const Form = loadable(() => import('components/Organisms/FormRegister'));
const LayoutAuth = loadable(() => import('components/Organisms/LayoutAuth'));

const StyledLogo = styled(Logo)`
  width: 100%;
  height: 140px;

  @media (max-width: ${theme.breakpoints.values.sm}px) {
    height: 100px;
  }
`;

const Register = ({ handleOpenTroubleLoggingInModal }) => {
  const { organizationId, propertyId, features } = useContext(AppContext);
  const history = useHistory();
  const formProps = useFormProps();

  const baseURL = `/${organizationId}/${propertyId}`;
  const intent = getLocalUnitIntentData();

  const onSubmitSuccess = ({ token, sanitizedUser }) => {
    setLocalAuth({
      token,
      sanitizedUser,
    });

    return history.push(baseURL);
  };

  return (
    <LayoutAuth>
      <StyledLogo padBottom />
      <Typography variant={'h2'} align={'center'}>
        Create Applicant Account
      </Typography>
      <Typography variant={'h4'} align={'center'}>
        Already have an account? <Link to={baseURL}>Click Here</Link>
      </Typography>
      <Form
        handleOpenTroubleLoggingInModal={handleOpenTroubleLoggingInModal}
        onSubmitSuccess={onSubmitSuccess}
        unitDetails={
          features.isAssigningUnitsAtApplicationEnabled && intent.state
            ? {
                moveInDate: intent.state?.unitMoveInDate,
                moveInDateTo: intent.state?.unitMoveInEndDate,
                numberOfBeds: intent.state?.floorPlanBeds,
              }
            : {}
        }
        {...formProps}
      />
    </LayoutAuth>
  );
};

export default Register;
